import { useState } from 'react';
import PrivateRouteList from '../../routes/PrivateRouteList';
import { Layout as Layouts } from 'antd';
import Sidebar from './sidebar';
import Header from './header';
import Footer from './footer';
import { fadeIn } from 'react-animations';
import styled, { keyframes } from 'styled-components';

const { Content } = Layouts;
const fadeInAnimation = keyframes`${fadeIn}`;

const FadeInDiv = styled.div`
    animation: 1s ${fadeInAnimation};
`;

const LayoutRoute = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [broken, setBroken] = useState(false);

    return (
        <Sidebar
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            broken={broken}
            setBroken={setBroken}
        >
            <MainLayout>
                <PrivateRouteList />
            </MainLayout>
        </Sidebar>
    );
};

const MainLayout = ({ children }) => {
    return (
        <Layouts className="site-layout">
            <Header />
            <Content className="mx-8 mb-8">
                <FadeInDiv>{children}</FadeInDiv>
            </Content>
            <Footer />
        </Layouts>
    );
};

export default LayoutRoute;
